import { render, staticRenderFns } from "./fansShow.vue?vue&type=template&id=bc18bd40&scoped=true&"
import script from "./fansShow.vue?vue&type=script&lang=js&"
export * from "./fansShow.vue?vue&type=script&lang=js&"
import style0 from "./fansShow.vue?vue&type=style&index=0&id=bc18bd40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc18bd40",
  null
  
)

export default component.exports